import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Phone, MessageCircle, ArrowRight } from "lucide-react";
import { FadeUp } from "./Reveal";
import { PHONE_TEL, PHONE_DISPLAY, waLink } from "../data/site";

export function CtaBanner({ title = "STRANDED? DON'T WAIT.", sub = "A Motion Tyres van is 30–60 minutes away, day or night. Call now or drop your location on WhatsApp." }) {
  return (
    <section className="relative overflow-hidden border-y border-[#27272A] bg-[#131316]" data-testid="cta-banner">
      <div
        className="absolute -top-40 -right-40 w-[480px] h-[480px] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(255,85,0,0.22) 0%, transparent 70%)" }}
      />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-24 flex flex-col lg:flex-row lg:items-center gap-10 justify-between">
        <FadeUp>
          <h2 className="font-display font-extrabold uppercase text-4xl sm:text-6xl leading-[0.95] text-white max-w-2xl">
            {title}
          </h2>
          <p className="mt-4 text-zinc-400 max-w-xl">{sub}</p>
        </FadeUp>
        <FadeUp delay={0.12} className="flex flex-col sm:flex-row gap-3 shrink-0">
          <a
            href={PHONE_TEL}
            data-testid="cta-banner-call-button"
            className="btn-glow flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-[#FF5500] hover:bg-[#FF6A1A] text-black font-telemetry text-sm font-semibold uppercase tracking-[0.12em]"
          >
            <Phone className="w-4 h-4" /> Call {PHONE_DISPLAY}
          </a>
          <a
            href={waLink("Hi Motion Tyres — I need a tyre fitting. Here's my location:")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-banner-whatsapp-button"
            className="flex items-center justify-center gap-2 px-8 py-4 rounded-full border border-emerald-500/60 text-emerald-400 hover:bg-emerald-500 hover:text-black transition-colors font-telemetry text-sm uppercase tracking-[0.12em]"
          >
            <MessageCircle className="w-4 h-4" /> WhatsApp
          </a>
        </FadeUp>
      </div>
    </section>
  );
}

export function NextStrip() {
  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10">
      <FadeUp className="flex flex-wrap items-center gap-3" >
        <span className="font-telemetry text-[11px] uppercase tracking-[0.25em] text-zinc-500 mr-2">
          Also on the road
        </span>
        <Link to="/services/tyre-fitting" className="text-sm text-zinc-400 hover:text-[#FF5500] transition-colors" data-testid="strip-tyre-fitting">Tyre Fitting</Link>
        <ArrowRight className="w-3 h-3 text-zinc-600" />
        <Link to="/services/wheel-alignment" className="text-sm text-zinc-400 hover:text-[#FF5500] transition-colors" data-testid="strip-wheel-alignment">Wheel Alignment</Link>
        <ArrowRight className="w-3 h-3 text-zinc-600" />
        <Link to="/contact" className="text-sm text-zinc-400 hover:text-[#FF5500] transition-colors" data-testid="strip-contact">Book a visit</Link>
      </FadeUp>
    </div>
  );
}
